if (!customElements.get("hoculus-add-on-product")) {
  class HoculusAddOnProduct extends HTMLElement {
  
    constructor() {
      super();
      this.cart = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.parentKeyInput = this.querySelector('input[name="items[0][parent_line_key]"]')
      this.parentId = this.getAttribute('data-parent-id');
      this.quantityInput = this.querySelector('input[name="items[0][quantity]"]');
      this.form = this.querySelector('form');
      this.submitBtn = this.querySelector('button[type="submit"]');
      this.defaultMessage = this.querySelector('.btn-label--default');
      this.successMessage = this.querySelector('.btn-label--success');
      this.errorMessage = this.querySelector('.btn-label--error');
    }
  
    connectedCallback() {
      document.addEventListener('hoculus:cart:update', (e) => this.processCart.bind(this)(e.detail));
      this.form.addEventListener('submit', (event) => this.handleSubmit.bind(this)(event));
      this.disableSubmitButton();
    }

    updateAttributes(parentKey, parentQuantity) {
      this.parentKeyInput.value = parentKey;
      this.quantityInput.value = parentQuantity;
    }

    enableSubmitButton() {
      this.submitBtn.style.pointerEvents = 'auto';
      this.submitBtn.style.cursor = 'pointer';
      this.submitBtn.style.opacity = '1';
    }
    
    disableSubmitButton() {
      this.submitBtn.style.pointerEvents = 'none';
      this.submitBtn.style.cursor = 'not-allowed';
      this.submitBtn.style.opacity = '0.5';
    }

    showSuccessMessage() {
      this.defaultMessage.style.display = 'none';
      this.successMessage.style.display = '';
      this.disableSubmitButton();
    }

    showErrorMessage(message) {
      this.errorMessage.textContent = message || 'An error occurred while adding the item to the cart.';
      this.errorMessage.style.display = 'flex';
      setTimeout(() => {
        this.errorMessage.style.display = 'none';
        this.defaultMessage.style.display = '';
      }, 2000);
    }

    handleSubmit(event) {
      event.preventDefault();
      let formData = new FormData(this.form, this.submitBtn);
      let _this = this;
      const body = {
        items: [{
          id: formData.get('items[0][id]'),
          quantity: formData.get('items[0][quantity]'),
          parent_line_key: formData.get('items[0][parent_line_key]'),
          properies:{
            '_add_on':'true'
          }
        }]
      }
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
      })
      .then(response => {
        const status = response.status;
        return response.json().then(data => ({ status, data }));
      })
      .then(({ status, data }) => {
        if(status !== 200) {
          _this.showErrorMessage(data.message);
        }else{
          _this.showSuccessMessage();
          window.hoculusItemAddedCallback();
        }
      })
      .catch((error) => {
        _this.showErrorMessage(error);
        console.error('Error:', error);
      })
      .finally(() => {
        _this.disableSubmitButton();
      });
    }

    processCart(cart){
      this.disableSubmitButton();
      const newItems = cart.items.filter(item => item.id == this.parentId).filter((item) => !this.cart.items.find((oldItem) => (oldItem.key == item.key)));
      const changedItems = cart.items.filter(item => item.id == this.parentId).filter((item) => this.cart.items.find((oldItem) => (oldItem.key == item.key && item.quantity != oldItem.quantity))).map((item) => {
        return {
          ...item, 
          oldQuantity: this.cart.items.find((oldItem) => oldItem.key == item.key).quantity
        };
      });
      this.cart = cart;
      if(newItems.length > 0){
        this.enableSubmitButton();
        this.updateAttributes(newItems[0].key, newItems[0].quantity);
      }
      if(changedItems.length > 0){
        this.enableSubmitButton();
        this.updateAttributes(changedItems[0].key, changedItems[0].quantity - changedItems[0].oldQuantity);
      }
    }
    
  }
  
  customElements.define("hoculus-add-on-product", HoculusAddOnProduct);
}